import { useQuery } from '@tanstack/react-query'
import { getOrganization } from '../lib/api'
import { useAppStore } from '../stores/app'

export function useOrganization() {
  const organizationId = useAppStore((state) => state.organizationId)

  const { data: org, isLoading, error } = useQuery({
    queryKey: ['organization', organizationId],
    queryFn: getOrganization,
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(organizationId),
  })

  const isPlanActive = org
    ? ['active', 'trialing'].includes(org.subscription_status) &&
      (!org.current_period_end || new Date(org.current_period_end) > new Date())
    : false

  const daysLeftInTrial =
    org?.subscription_status === 'trialing' && org.current_period_end
      ? Math.max(
          0,
          Math.ceil(
            (new Date(org.current_period_end).getTime() - Date.now()) / 86400000
          )
        )
      : null

  return { org, isLoading, error, isPlanActive, daysLeftInTrial }
}
